var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 12,
    height: 12,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.999 2C17.522 2 21.999 6.477 21.999 12C21.999 17.523 17.522 22 11.999 22C6.47602 22 1.99902 17.523 1.99902 12C1.99902 6.477 6.47602 2 11.999 2ZM15.534 8.381L10.584 13.331L8.46402 11.21C8.37118 11.1171 8.26094 11.0434 8.13961 10.9931C8.01828 10.9428 7.88823 10.9168 7.75688 10.9168C7.49161 10.9167 7.23716 11.022 7.04952 11.2095C6.86188 11.397 6.75641 11.6514 6.75632 11.9166C6.75623 12.1819 6.86152 12.4364 7.04902 12.624L9.80702 15.382C9.90917 15.4842 10.0305 15.5653 10.164 15.6206C10.2974 15.6759 10.4405 15.7044 10.585 15.7044C10.7295 15.7044 10.8726 15.6759 11.0061 15.6206C11.1396 15.5653 11.2609 15.4842 11.363 15.382L16.949 9.796C17.1367 9.60836 17.2421 9.35386 17.2421 9.0885C17.2421 8.82314 17.1367 8.56864 16.949 8.381C16.7614 8.19336 16.5069 8.08794 16.2415 8.08794C15.9762 8.08794 15.7217 8.19336 15.534 8.381Z",
    fill: "#15A74F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.824057f134e0e015217e4f48fd0e042d.svg";
export { ForwardRef as ReactComponent };